import React from 'react';
import { useTranslation } from 'react-i18next';

interface StudentExitStatusProps {
  status: 'pending' | 'approved' | 'rejected' | 'completed';
  text?: string;
}

const StudentExitStatusBadge: React.FC<StudentExitStatusProps> = ({ status, text }) => {
  const { t } = useTranslation();
  
  const getBadgeStatus = () => {
    switch (status) {
      case 'pending':
        return 'warning';
      case 'approved':
        return 'info';
      case 'rejected':
        return 'danger';
      case 'completed':
        return 'success';
      default:
        return 'secondary';
    }
  };

  const getDefaultText = () => {
    switch (status) {
      case 'pending':
        return t('studentExit.status.pending');
      case 'approved':
        return t('studentExit.status.approved');
      case 'rejected':
        return t('studentExit.status.rejected');
      case 'completed':
        return t('studentExit.status.completed');
      default:
        return t('unknown');
    }
  };

  const getStatusIcon = () => {
    switch (status) {
      case 'pending':
        return 'ti ti-clock';
      case 'approved':
        return 'ti ti-check';
      case 'rejected':
        return 'ti ti-x';
      case 'completed':
        return 'ti ti-checkbox';
      default:
        return 'ti ti-circle-filled';
    }
  };

  return (
    <span className={`badge badge-soft-${getBadgeStatus()} d-inline-flex align-items-center`}>
      <i className={`${getStatusIcon()}  me-1`}></i>
      {text || getDefaultText()}
    </span>
  );
};

export default StudentExitStatusBadge;